import { render, staticRenderFns } from "./ProductServe.vue?vue&type=template&id=66b25086&scoped=true&"
import script from "./ProductServe.vue?vue&type=script&lang=js&"
export * from "./ProductServe.vue?vue&type=script&lang=js&"
import style0 from "./ProductServe.vue?vue&type=style&index=0&id=66b25086&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b25086",
  null
  
)

export default component.exports